module.exports = "/images/Roofing---Screenshots.jpg";